export const PARENTS_LIMIT_EXCEEDED_ERROR_CODE = 'parents-limit-exceeded';
export const PARENTS_LIMIT_EXCEEDED_FOR_EXISTING_PARENT_ERROR_CODE =
  'parents-limit-exceeded-for-existing-parent';

export const isParentsLimitExceededErrorCode = (
  errorCode: string | undefined,
): boolean =>
  errorCode === PARENTS_LIMIT_EXCEEDED_ERROR_CODE ||
  errorCode === PARENTS_LIMIT_EXCEEDED_FOR_EXISTING_PARENT_ERROR_CODE;

// トークンはメモリ上にしか持たないので、再読み込みや直接のアクセスでは無くなる
export const invitationTokenMissingError = {
  title: 'ページを表示できません',
  description: '招待メールのリンクから、もう一度開いてください。',
} as const;

export const parentsLimitExceededError = {
  title: '保護者を紐付けできません',
  descriptionLines: [
    'すでに保護者が最大数まで紐付けられています。',
    '招待メール送信者に人数調整を依頼してください。',
  ],
} as const;
